import { render, staticRenderFns } from "./AppSharedExpenses.vue?vue&type=template&id=64043b79&scoped=true"
import script from "./AppSharedExpenses.vue?vue&type=script&lang=js"
export * from "./AppSharedExpenses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64043b79",
  null
  
)

export default component.exports